import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoginService, SurveyService } from 'src/_services';
import { SaveSurveyModalComponent } from './save-survey-modal/save-survey-modal.component';
import { SearchType } from 'models';

@Component({
  selector: 'app-save-button',
  standalone: true,
  imports: [],
  templateUrl: './save-button.component.html',
  styleUrl: './save-button.component.css'
})
export class SaveButtonComponent {

  @Input() saveType: SearchType;

  changesSaved: boolean = true;

  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private login: LoginService,
    private survey: SurveyService
  ) {}

  openSaveSurveyModal() {
    if (this.login.isAuthenticated) {
      const dialogRef = this.dialog.open(SaveSurveyModalComponent, {
        width: '400px',
        data: this.saveType
      })
  
      dialogRef.afterClosed().subscribe(
        result => {
          if (result && result != 'canceled') {
            this.changesSaved = (result == 'success');
            const snackbarMessage = (result == 'success') ? 'La ricerca è stata salvata correttamente' : 'Sono stati riscontrati dei problemi durante il salvataggio';
            this.snackBar.open(snackbarMessage, 'Chiudi', { duration: 5000 });
          }
        }
      )
    }
    else { this.login.showLoginIsRequiredMsg(this.survey.getQuestions()); }
  }
}
